module.exports = __webpack_public_path__ + "img/logo.c915a0d4.png";